import SummaryByBranchTable from "./summaryByBranchTable.container";

export default SummaryByBranchTable;
